import React, { useRef, useEffect } from "react";

const AnimatedBackground = () => {
    const canvasRef = useRef(null);
    const isMobileView = window.innerWidth <= 768; // Perform the check once

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const points = [];
        let frame = 0;

        // Create scatter points
        const scatterPointsNumber = isMobileView ? 10 : 30; // Adjusted for mobile view
        for (let i = 0; i < scatterPointsNumber; i++) { // Reduced the number of scatter points
            points.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                radius: Math.random() * 3 + 1,
                dx: (Math.random() - 0.8) * 0.2,
                dy: (Math.random() - 0.5) * 0.2,
            });
        }

        const draw = () => {
            ctx.fillStyle = "#F8F8F8"; // Grey White
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw gradient background
            const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            // gradient.addColorStop(0, "#F8F8F8");      // Very light at the top
            // gradient.addColorStop(0.5, "#F8F8F8");      // Very light at the top
            // gradient.addColorStop(0.6, "#e6eaff");   // Soft blue
            // gradient.addColorStop(0.7, "#a6aaff");    // Soft purple/blue
            // gradient.addColorStop(0.85, "#6e7fff");   // Medium blue/purple
            // gradient.addColorStop(1, "#3a5de8");      // Deep blue at the bottom
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw scatter points
            // points.forEach((point) => {
            //     ctx.beginPath();
            //     ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2);
            //     ctx.fillStyle = "rgba(0, 188, 212, 0.8)"; // Cyan scatter points
            //     ctx.fill();

            //     // Move points
            //     point.x += point.dx;
            //     point.y += point.dy;

            //     // Bounce off edges
            //     if (point.x < 0 || point.x > canvas.width) point.dx *= -1;
            //     if (point.y < 0 || point.y > canvas.height) point.dy *= -1;
            // });

            // frame++;
            // requestAnimationFrame(draw);
        };

        draw();

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        window.addEventListener("resize", resizeCanvas);
        return () => window.removeEventListener("resize", resizeCanvas);
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
            }}
        ></canvas>
    );
};

export default AnimatedBackground;
